<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    Link
  </app-header-dialog>


  <div *ngIf="entityForm">

    <div class="content">

      <mat-form-field appearance="outline" style="margin-top: 10px;">
        <mat-label>Tipo de Link</mat-label>
        <mat-select [errorStateMatcher]="matcher" [formControl]="entityForm.controls.type">
          <mat-option *ngFor="let type of types" [value]="type.id">
            {{ type.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="entityForm.controls.type.hasError('required')">
          Selecione um tipo
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
          autocomplete="off">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Link</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.link"
          autocomplete="off">
      </mat-form-field>

    </div>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
      <button *ngIf="!isEdit" matTooltip='Inserir' mat-raised-button
        (click)="matDialogRef.close(['insert', entityForm])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>
      <button *ngIf="isEdit" matTooltip='Alterar' mat-raised-button (click)="matDialogRef.close(['update', entityForm])"
        [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

    </div>

  </div>

</div>